import {
  Alert,
  Avatar,
  Box,
  CircularProgress,
  Grid,
  Link,
  Paper,
  Typography,
} from "@mui/material";
import React, { FC, useState } from "react";
import successCheckMark from "../../assets/images/Success_Check_Mark.svg";
import {
  getEmailAndCodeForPasswordReset,
  sendPasswordResetEmail,
} from "../../lib/auth";
import { mapCognitoError } from "../../lib/cognito";
import { ForgotPasswordPageProps } from "./ForgotPasswordPage";
import LandingPageWrapper from "./LandingPageWrapper";

const ForgotPasswordEmailSentPage: FC<ForgotPasswordPageProps> = (props) => {
  const [authenticating, setAuthenticating] = useState<boolean>(false);
  const [error, setError] = useState("");

  const signInLink = "/sign-in";
  const forgotPasswordEmailSentLink = "/forgot-password-email-sent";

  const resendResetPasswordEmail = (event: React.MouseEvent<unknown>) => {
    event.preventDefault();

    setAuthenticating(true);

    const { emailForPasswordReset } = getEmailAndCodeForPasswordReset();

    sendPasswordResetEmail(emailForPasswordReset, props.clientMetadata)
      .then((result) => {
        setAuthenticating(false);
        if (!result.success) {
          setError("Unknown password reset error occured.  Please try again.");
        }
      })
      .catch((err) => {
        setAuthenticating(false);
        setError(mapCognitoError(err));
      });
  };

  return (
    <LandingPageWrapper>
      <Paper elevation={9} sx={{ borderRadius: 10 }}>
        {authenticating ? (
          <Box
            sx={{
              width: "100%",
              height: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ px: 4, py: 4 }}>
            {error && (
              <Alert sx={{ width: "100%" }} severity="error">
                {error}
              </Alert>
            )}
            {/* Header */}
            <Box component="header" sx={{ mb: 3 }}>
              <Avatar
                alt="Password reset email successfully sent"
                src={successCheckMark}
                sx={{
                  // Possibly change the sizing of this icon
                  width: 48,
                  height: 48,
                }}
              />
            </Box>

            {/* Body */}
            <Box>
              <Typography component="h1" variant="h5">
                We have sent a verification code to your email address.
              </Typography>
              <Typography component="h2" variant="body2" sx={{ mt: 1 }}>
                Click the link in your email address to reset your password and
                login.
              </Typography>
            </Box>

            {/* Footer */}
            <Box sx={{ mt: 4 }}>
              <Grid container spacing={2}>
                <Grid size={6}>
                  <Link href={signInLink} underline="hover">
                    Back to Login
                  </Link>
                </Grid>
                <Grid size={6}>
                  <Link
                    href={forgotPasswordEmailSentLink}
                    onClick={resendResetPasswordEmail}
                    underline="hover"
                  >
                    Resend Link
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Paper>
    </LandingPageWrapper>
  );
};

export default ForgotPasswordEmailSentPage;
